<template>
  <div class="admin-empty-state text-center py-2 px-1">
    <div class="admin-empty-state__icon rounded-circle d-inline-flex align-items-center justify-content-center mb-75">
      <feather-icon :icon="icon" size="22" />
    </div>
    <p class="admin-empty-state__title font-weight-bold mb-25">
      {{ title }}
    </p>
    <p v-if="description" class="admin-empty-state__desc text-muted small mb-0 mx-auto">
      {{ description }}
    </p>
    <div v-if="$slots.default" class="mt-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminEmptyState',
  props: {
    icon: { type: String, default: 'InboxIcon' },
    title: { type: String, default: 'Nothing here yet' },
    description: { type: String, default: '' },
  },
}
</script>

<style scoped>
.admin-empty-state__icon {
  width: 3rem;
  height: 3rem;
  background: rgba(130, 134, 139, 0.12);
  color: #82868b;
}
.admin-empty-state__title {
  font-size: 0.9375rem;
  margin-bottom: 0.25rem;
}
.admin-empty-state__desc {
  max-width: 22rem;
  line-height: 1.45;
}
</style>
